// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3uvPH","errorLogs":"styles_errorLogs__SJVSK"};